import { Controller } from 'stimulus'

export default class extends Controller {
    static targets = ['company', 'customerType']

    connect() {
        this.companyTarget.style.display = 'none'

        // Use jQuery event listener to make the listening work.
        $(this.customerTypeTarget).on('change', (event) => { this.toggleType(event) })
        $(this.customerTypeTarget).trigger('change');
    }

    toggleType(event) {
        if (event.target.value == 'business') {
            this.companyTarget.style.display = 'block'
        } else {
            this.companyTarget.style.display = 'none'
        }
    }
}
